import { render } from "./location_list.vue?vue&type=template&id=4cdb1b73"
import script from "./location_list.vue?vue&type=script&lang=js"
export * from "./location_list.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__